(() => {
  const excludedPath = /^\/(?:cart|checkout|checkouts|account)(?:\/|$)/;

  const shouldSkip = (url) => {
    if (window.Shopify?.designMode) return true;
    if (!url) return false;

    try {
      const destination = new URL(url, window.location.href);
      return destination.origin !== window.location.origin || excludedPath.test(destination.pathname);
    } catch (_error) {
      return true;
    }
  };

  window.addEventListener('pageswap', (event) => {
    const destinationUrl = event.activation?.entry?.url;
    if (event.viewTransition && shouldSkip(destinationUrl)) {
      event.viewTransition.skipTransition();
    }
  });

  window.addEventListener('pagereveal', (event) => {
    if (event.viewTransition && shouldSkip(window.location.href)) {
      event.viewTransition.skipTransition();
    }
  });
})();
